import { render } from "./ArgonButton.vue?vue&type=template&id=49dfc458"
import script from "./ArgonButton.vue?vue&type=script&lang=js"
export * from "./ArgonButton.vue?vue&type=script&lang=js"
script.render = render

export default script